import { useQuery } from '@tanstack/react-query'
import { AnimalController } from 'src/controllers/animal.controller'
import { BloodGradeDto } from 'src/dto/animal.dto'

const animalController = new AnimalController()

export function useGetBloodGradeList() {
  return useQuery<BloodGradeDto[], Error>({
    queryKey: ['getBloodGradeList'],
    queryFn: () => animalController.getBloodGradeList()
  })
}
